import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { buildApiUrl } from "../config/api";

const SignupSchema = Yup.object().shape({
  login: Yup.string()
    .min(2, "Занадто коротко")
    .max(50, "Занадто довго")
    .required("Обов'язкове поле"),
  password: Yup.string()
    .min(2, "Занадто коротко")
    .max(50, "Занадто довго")
    .required("Обов'язкове поле"),
});

export const ValidationSchemaLogin = () => (
  <div className="page">
    <h1>Вхід до адмінки</h1>
    <Formik
      initialValues={{
        login: "",
        password: "",
      }}
      className="test"
      validationSchema={SignupSchema}
      onSubmit={async (values) => {
        try {
          const res = await fetch(buildApiUrl("/api/admin/login"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(values),
            credentials: "include", // важно, чтобы куки сохранились
          });

          const data = await res.json();
          if (res.ok) {
            console.log("Успішний вхід");

              document.cookie = `authToken=${data.token}; path=/; max-age=${60 * 60 * 24 * 60}; samesite=strict`;
              window.location.href = "/time";
              localStorage.setItem("authToken", data.token)

          } else {
            console.error(data.error);
          }
        } catch (err) {
          console.error(err);
        }
      }}
    >
      {({ errors, touched }) => (
        <Form className="box-form-login">
          <div className="field">
            <label>Логін</label>
            <Field name="login" type="text" />
            {errors.login && touched.login ? (
              <div className="error-label">{errors.login}</div>
            ) : null}
          </div>

          <div className="field">
            <label>Пароль</label>
            <Field name="password" type="password" />
            {errors.password && touched.password ? (
              <div className="error-label">{errors.password}</div>
            ) : null}
          </div>

          <button className="button" type="submit">
            Увійти
          </button>
        </Form>
      )}
    </Formik>
  </div>
);
